import { useNavigate } from 'react-router-dom';
import { MessageSquareLock } from 'lucide-react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';

export const MESSAGING_UPGRADE_MESSAGE = 'Access the Primary Plan to unlock messaging.';

/**
 * True when an API error is the backend's plan-gating upsell (402) — e.g. a
 * Head Start school trying to send a message. Callers show the upgrade modal
 * instead of a generic "Failed to send message" toast.
 */
export function isUpsellError(error) {
  return error?.response?.status === 402;
}

/**
 * Upgrade prompt shown when a Head Start school admin tries to send/reply to a
 * message. Rendered on top of the open messaging modal; "Cancel" only closes
 * this prompt so the messaging modal (and the typed draft) stays intact.
 */
export function MessagingUpgradeDialog({ open, onOpenChange }) {
  const navigate = useNavigate();

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="w-[calc(100%-2rem)] rounded-xl sm:max-w-md" data-testid="messaging-upgrade-dialog">
        <AlertDialogHeader>
          <div className="mx-auto sm:mx-0 h-11 w-11 rounded-full bg-emerald-100 flex items-center justify-center mb-1">
            <MessageSquareLock className="h-5 w-5 text-emerald-700" />
          </div>
          <AlertDialogTitle className="font-['Manrope']">Messaging is a Primary Plan feature</AlertDialogTitle>
          <AlertDialogDescription data-testid="messaging-upgrade-message">
            {MESSAGING_UPGRADE_MESSAGE}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="messaging-upgrade-cancel-btn">Cancel</AlertDialogCancel>
          <AlertDialogAction
            className="bg-emerald-600 hover:bg-emerald-700"
            onClick={() => navigate('/employer/subscription')}
            data-testid="messaging-upgrade-cta-btn"
          >
            View Primary Plan
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
